export const featureFlag = {
  switchIn: 'Redtail_Imaging_SwitchIn',
  fileStats: 'Redtail_Imaging_FileStatsChart',
  folderColors: 'Redtail_Imaging_FolderColors',
  maintenanceMode: 'Redtail_Imaging_MaintenanceMode',
  folderTreeView: 'Redtail_Imaging_Folder_Tree_view',
  sharing: 'Redtail_Imaging_Sharing',
  helpLibrary: 'RT_13673_HELP_LIBRARY'
};

export type FeatureFlag = (typeof featureFlag)[keyof typeof featureFlag];
